import { useState } from 'react';
import { Link } from 'react-router-dom';
import { searchSites } from '@/mocks/sites';

export default function HeroSection() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<ReturnType<typeof searchSites>>([]);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = (value: string) => {
    setQuery(value);
    if (value.trim().length > 0) {
      setResults(searchSites(value));
      setShowResults(true);
    } else {
      setResults([]);
      setShowResults(false);
    }
  };

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20gradient%20background%20with%20soft%20warm%20yellow%20and%20cream%20tones%2C%20gentle%20geometric%20shapes%20floating%20organically%2C%20clean%20modern%20design%20with%20subtle%20texture%2C%20bright%20airy%20atmosphere%2C%20digital%20navigation%20concept%20with%20soft%20nodes%20and%20connections%2C%20peaceful%20and%20professional%20aesthetic&width=1600&height=900&seq=hero-lemon-nav&orientation=landscape"
          alt="柠檬导航背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/8 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading leading-tight">
          精选优质网站，导航无限可能
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
          柠檬导航精心筛选海量优质网站资源，分类清晰、更新及时，助您快速找到所需，开启高效上网之旅
        </p>

        {/* Search */}
        <div className="relative max-w-lg mx-auto">
          <div className="flex items-center bg-white/95 backdrop-blur-sm rounded-full px-5 py-3.5 shadow-lg">
            <i className="ri-search-line text-foreground-400 text-lg mr-3"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => handleSearch(e.target.value)}
              onFocus={() => query.trim() && setShowResults(true)}
              onBlur={() => setTimeout(() => setShowResults(false), 200)}
              placeholder="搜索网站名称、关键词..."
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder-foreground-400 outline-none"
            />
            {query && (
              <button
                onClick={() => { setQuery(''); setResults([]); setShowResults(false); }}
                className="ml-2 text-foreground-400 hover:text-foreground-600 cursor-pointer"
              >
                <i className="ri-close-circle-line"></i>
              </button>
            )}
          </div>

          {/* Dropdown results */}
          {showResults && results.length > 0 && (
            <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-xl shadow-xl border border-background-200 py-2 max-h-72 overflow-y-auto z-20">
              {results.map((site) => (
                <a
                  key={site.id}
                  href={site.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-3 px-4 py-3 hover:bg-background-50 transition-colors cursor-pointer text-left"
                >
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${site.icon} text-primary-600 text-sm`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900 truncate">{site.name}</p>
                    <p className="text-xs text-foreground-500 truncate">{site.description}</p>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {site.tags[0]}
                  </span>
                </a>
              ))}
            </div>
          )}

          {showResults && query.trim() && results.length === 0 && (
            <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-xl shadow-xl border border-background-200 py-6 text-center z-20">
              <p className="text-sm text-foreground-500">未找到相关网站</p>
            </div>
          )}
        </div>

        {/* Stats */}
        <div className="flex items-center justify-center gap-8 md:gap-12 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">200+</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">精选网站</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">8</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">核心分类</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">10万+</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">月活跃用户</p>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60">
        <span className="text-xs">向下探索</span>
        <i className="ri-arrow-down-line animate-bounce text-sm"></i>
      </div>
    </section>
  );
}